export default __webpack_public_path__ + "static/media/app_disconnected.4b9bd74a.svg";